import { sectionNav } from '@/mocks/mikami/sections';

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="px-4 py-12 md:px-8 md:py-16">
        <div className="grid gap-10 lg:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-film-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold tracking-wide text-background-50">三上悠亚电影</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200">
              一个围绕主题的资讯整理页，把新片、最新动态、消息、写真、活动与近况集中到一个页面，按方向分类呈现，方便按需查阅与核对。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {['新片', '最新', '消息', '写真', '活动', '近况'].map((tag) => (
                <span
                  key={tag}
                  className="rounded-full border border-background-50/20 px-2.5 py-0.5 text-xs font-label text-background-200"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <nav>
            <h2 className="font-heading text-sm font-bold tracking-wide text-background-50">页面分区</h2>
            <ul className="mt-4 grid grid-cols-2 gap-2.5 text-sm">
              {sectionNav.map((item) => (
                <li key={item.id}>
                  <a
                    href={`#${item.id}`}
                    className="cursor-pointer text-background-200 transition-colors hover:text-accent-300"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h2 className="font-heading text-sm font-bold tracking-wide text-background-50">浏览提示</h2>
            <ul className="mt-4 space-y-2.5 text-sm text-background-200">
              <li className="flex items-start gap-2">
                <i className="ri-arrow-right-s-line mt-0.5 text-accent-300"></i>
                条目为方向性整理，具体以官方发布为准。
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-arrow-right-s-line mt-0.5 text-accent-300"></i>
                筛选与搜索仅作用于本页已有的内容。
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-arrow-right-s-line mt-0.5 text-accent-300"></i>
                请理性看待各类消息，注意核对来源出处。
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-50/15 pt-6 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between">
          <p>本页为公开信息整理与内容索引，不提供任何在线播放与下载服务。</p>
          <p>三上悠亚电影 · 资讯整理页</p>
        </div>
      </div>
    </footer>
  );
}